export const locale = {
  lang: 'pt',
  data: {
    'PORTAL': {
      'BTN_SCREE_SHO': 'Take screenshot',
      'TOTALCOLA':'Total de colaboradores',
      'TOTALFAL': 'Colaboradores que ainda não respondem',
      'TOTALCONT':'Colaboradores que já responderam',
      'TOTALPRO': 'Progresso total',
      'REPORTE':'Número recomendado de respostas para...',
      'RANKING':'Número mínimo de respostas para...',
      'TOOLT_REPORTE':'Número recomendado de respostas para a entrega de resultados estatisticamente significativos por corte demográfico',
      'TOOLT_RANKING':'Número mínimo de respostas para Certificação/Ranking da empresa',

      'REPORTE_CER_CARCA':'Número recomendado de respostas a...',
      'TOOLT_REPORTE_CER_CARCA':'Número recomendado de respostas para fornecer resultados estatisticamente por corte demográfico, levando em conta que cada opção terá 5 respostas',
      'RANKING_CER_CARCA':'Número mínimo de respostas a...',
      'TOOLT_RANKING_CER_CARCA':'Número mínimo de respostas para Certificação / Ranking da organização',

      'REPORTE_MED_CARCA':'Número recomendado de respostas a...',
      'TOOLT_REPORTE_MED_CARCA':'Número recomendado de respostas para fornecer resultados estatisticamente por corte demográfico, levando em conta que cada opção terá 5 respostas',
      'RANKING_MED_CARCA':'Número mínimo de respostas a...',
      'TOOLT_RANKING_MED_CARCA':'Número mínimo de respostas para Certificação / Ranking da organização',

      'TOTALLOG':'Pessoas que ainda não concluíram a pesquisa, mas que já começaram',
      'TOTALMIN':'Número mínimo de funcionários necessário',
      'TOTALGONE':'Pessoas que decidiram não responder',
      'SELECTFPLA': 'Filtros',
      'TBARRAPROGRESO':'Progresso atual',
      'ACCESODENEGADO': 'Link de acesso expirado',
      'ACCESOMSJPRE_1': 'A data de encerramento do inquérito foi atingida, este portal ainda estará activo durante ',
      'ACCESOMSJPRE_2': ' dias',
      'BTNOK': 'OK',
      'DIARESTA':'Días restantes',
      'COLAB':'Colaboradores',
      'NO-INFO':'Informações ausentes no banco de dados de colaboradores',
      'PORTAL_V1':'Portal de contagem V1',
      'PORTAL_V2':'Portal de contagem V2',
      'DI-TRANSCU':'Os dias passaram',
      'ETI_GRAFI_ZONA_HO': 'A data mostrada no gráfico é definida para a hora local em: ',
      'ETI_FILT_V1&V2': 'Os grupos marcados com (*) não mostram informações porque não possuem o número mínimo de usuários necessário para exibir o andamento ',
      'WAR_RESU_ARE_MIN5': 'O número mínimo de respostas para exibir resultados por área é de 5',
      'FILTROS':{
        '1': 'País',
        '2': 'Localização',
        '3': 'Área - Departamento',
        '4': 'Grau acadêmico',
        '5': 'Departamento',
        '6': 'Nível geográfico 1',
        '7': 'Nível geográfico 2',
        '8': 'Nível geográfico 3',
        '9': 'Nível geográfico 4',
        '10': 'Nível geográfico 5',
        '11': 'Nível geográfico 6',
        '12': 'Nível geográfico 7',
        '13': 'Nível geográfico 8',
        '14': 'Nível geográfico 9',
        '15': 'Nível geográfico 10',
        '16': 'Nível estrutural 1',
        '17': 'Nível estrutural 2',
        '18': 'Nível estrutural 3',
        '19': 'Nível estrutural 4',
        '20': 'Nível estrutural 5',
        '21': 'Nível estrutural 6',
        '22': 'Nível estrutural 7',
        '23': 'Nível estrutural 8',
        '24': 'Nível estrutural 9',
        '25': 'Nível estrutural 10',
        '26': 'Área de negócio',
        '27': 'Nível estrutural 2',
      },
      'COLUMNAS_TABLA':{
        'DEMOGRAFICO': 'Demográfico',
        'SEGMENTO': 'Segmento',
        'COLABORADORES_T': 'Número total de colaboradores',
        'PENDIENTES_RESPONDER': 'Colaboradores que ainda não responderam',
        'YA_RESPONDIERON': 'Colaboradores que já responderam',
        'AVANCE': 'Antevisão',
        'FILTERS': 'Filtros'
      },
      'EXCEL_V2':{
        'TITULO_AVANCE': 'Progresso na implementação da pesquisa por: ',
        'SHEET': 'Relatório',
        'DESCARGA': 'Portal de contagem de ',
        'MODAL_DESCARGA': 'Baixe corretamente'
      },
      'ETIQUETAS':{
        'ETIQUETAS': 'itens por página',
        'OF': 'de',
        'BOTON':'Reiniciar filtros'
      },
      'FILTROS_V2':{
        'ninguno': 'Nenhum',
        'Company': 'Companhia',
        'country': 'País',
        'location': 'Localização',
        'area': 'Área',
        'antiquity': 'Antiguidade',
        'generation': 'Geração',
        'charge': 'Posição',
        'homologado': 'Posição aprovada',
        'gender': 'Gênero',
        'typeofwork': 'Tipo de trabalho',
        'workCondition': 'Condições de trabalho',
        'academico': 'Grau acadêmico',
        'contratacion': 'tipo de contrato',
        'personal': 'Tipo de pessoal',
        'geo_1': 'Nível geográfico 1',
        'geo_uno': 'Nível geográfico 1',
        'geo_2': 'Nível geográfico 2',
        'geo_3': 'Nível geográfico 3',
        'geo_4': 'Nível geográfico 4',
        'geo_5': 'Nível geográfico 5',
        'geo_6': 'Nível geográfico 6',
        'geo_7': 'Nível geográfico 7',
        'geo_8': 'Nível geográfico 8',
        'geo_9': 'Nível geográfico 9',
        'geo_10': 'Nível geográfico 10',
        'structure_1': 'Nível estrutural 1',
        'structure_2': 'Nível estrutural 2',
        'structure_3': 'Nível estrutural 3',
        'structure_4': 'Nível estrutural 4',
        'structure_5': 'Nível estrutural 5',
        'structure_6': 'Nível estrutural 6',
        'structure_7': 'Nível estrutural 7',
        'structure_8': 'Nível estrutural 8',
        'structure_9': 'Nível estrutural 9',
        'structure_10': 'Nível estrutural 10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': 'Nível estrutural 1',
        'structure_DOS': 'Nível estrutural 2',
        'structure_TRES': 'Nível estrutural 3',
        'structure_CUATRO': 'Nível estrutural 4',
        'structure_CINCO': 'Nível estrutural 5',
        'structure_SEIS': 'Nível estrutural 6',
        'structure_SIETE': 'Nível estrutural 7',
        'structure_OCHO': 'Nível estrutural 8',
        'structure_NUEVE': 'Nível estrutural 9',
        'structure_DIEZ': 'Nível estrutural 10',
        'bUnit': 'Unidade de Negócios',

      },
      'FILTROS_V2_HK':{
        'ninguno': 'Nenhum',
        'Company': 'Companhia',
        'country': 'País',
        'location': 'Localização',
        'area': 'Departamento',
        'antiquity': 'Antiguidade',
        'generation': 'Geração',
        'charge': 'Posição ou função na empresa',
        'homologado': 'Posição aprovada',
        'gender': 'Gênero',
        'typeofwork': 'Tipo de trabalho',
        'workCondition': 'Condições de trabalho',
        'academico': 'Grau acadêmico',
        'contratacion': 'tipo de contrato',
        'personal': 'Tipo de pessoal',
        'geo_1': 'Nível geográfico 1',
        'geo_uno': 'Nível geográfico 1',
        'geo_2': 'Nível geográfico 2',
        'geo_3': 'Nível geográfico 3',
        'geo_4': 'Nível geográfico 4',
        'geo_5': 'Nível geográfico 5',
        'geo_6': 'Nível geográfico 6',
        'geo_7': 'Nível geográfico 7',
        'geo_8': 'Nível geográfico 8',
        'geo_9': 'Nível geográfico 9',
        'geo_10': 'Nível geográfico 10',
        'structure_1': 'Nível estrutural 1',
        'structure_2': 'Nível estrutural 2',
        'structure_3': 'Nível estrutural 3',
        'structure_4': 'Nível estrutural 4',
        'structure_5': 'Nível estrutural 5',
        'structure_6': 'Nível estrutural 6',
        'structure_7': 'Nível estrutural 7',
        'structure_8': 'Nível estrutural 8',
        'structure_9': 'Nível estrutural 9',
        'structure_10': 'Nível estrutural 10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': 'Nível estrutural 1',
        'structure_DOS': 'Nível estrutural 2',
        'structure_TRES': 'Nível estrutural 3',
        'structure_CUATRO': 'Nível estrutural 4',
        'structure_CINCO': 'Nível estrutural 5',
        'structure_SEIS': 'Nível estrutural 6',
        'structure_SIETE': 'Nível estrutural 7',
        'structure_OCHO': 'Nível estrutural 8',
        'structure_NUEVE': 'Nível estrutural 9',
        'structure_DIEZ': 'Nível estrutural 10',
        'bUnit': 'Unidade de Negócios',

      },
      'PRODUCTO':{
        'CERT':'Certificar',
        'MED':'Para dimensionar',
        'NOM35':'Regra 035',
        'PULSE':'Pulsecheck',
        'FOCUS':'Área de foco',
        'MEDIR_1': 'Melhoria da medição',
        'MEDIR_2': 'Medição + MST',
        'MEDIR_3': 'Medição por áreas',
        'MEDIR_4': 'Medição por líderes',
        'MEDIR_5': 'Medição por dimensões',
        'MEDIR_6': 'Medição para certificar',
        'NAME':'Companhia: ',
        'PRODUCTO':'Produtos: ',
        'PORTAL':'Portal de contagem ',
        'LEADER_GO':'Leader Go',
        'AMCO':'AMCO',
        'TRAB_DIGN':'Trabalho decente',
        'PRI_EMPLE':'Primeiro emprego',
      },
      'EXCEL':{
        'NOMBOTON': 'Exportar excel',
        'NOMBOTONREDUCIDO': 'Exportar para excel reduzido',
        'NOMEMPRE':'RAZÃO SOCIAL:',
        'NOMUSUARIO':'NOME DO USUÁRIO:',
        'NOMPROD':'NOME DO PRODUTO:',
        'FECHLANZA':'DATA DE LANÇAMENTO:',
        'FECHDESCA':'DATA DE DOWNLOAD:',
        'DRESTAN':'DIA RESTANTE:',
        'TOTALCOLA':'TOTAL DE COLABORADORES:',
        'TOTALFAL': 'COLABORADORES QUE AINDA NÃO RESPONDEM:',
        'TOTALCONT':'COLABORADORES QUE JÁ RESPONDERAM:',
        'TOTALPRO': 'PROGRESSO TOTAL:',
        'TOTALGONE':'Pessoas que decidiram não responder',
        'REPORTE':'ÍNDICE DE RESPOSTA PARA ENTREGAS:',
        'RANKING':'AMOSTRA PARA CERTIFICAÇÃO E CLASSIFICAÇÃO:',
        'FILT':'FILTRO:',
        'NOMFILT':'NOME DO FILTRO:',
        //pestaña principal
        'INFOGENE': 'Relatório geral',
        'FILTROSNAME':{
          'country':'país',
          'location':'Localização',
          'area':'área',
          'antiquity':'antiguidade',
          'generation':'geração',
          'charge':'carga',
          'homologado':'aprovado',
          'gender':'gênero',
          'typeofwork':'tipo de trabalho',
          'workCondition':'Condição de trabalho',
          'academico':'acadêmico',
          'contratacion':'Contratação',
          'personal':'pessoal',
          'geo_1':'geo_1',
          'geo_2':'geo_2',
          'geo_3':'geo_3',
          'geo_4':'geo_4',
          'geo_5':'geo_5',
          'structure_1':'estrutura_1',
          'structure_2':'estrutura_2',
          'structure_3':'estrutura_3',
          'structure_4':'estrutura_4',
          'structure_5':'estrutura_5',
          'structure_6':'estrutura_6',
          'structure_7':'estrutura_7',
          'structure_8':'estrutura_8',
          'structure_9':'estrutura_9',
          'structure_10':'estrutura_10',
        }

      },
      'TIPO-PERSONAL':{
        'TIPO':'Tipo Pessoal',
        '1':'Sindicado',
        '2':'Confiança',
        '3':'Ambos',
      }

    },
    'PORTAL35': {
      'TOTALCOLA':'Total de colaboradores',
      'TOTALFAL': 'Colaboradores que ainda não respondem',
      'TOTALCONT':'Colaboradores que já responderam',
      'TOTALPRO': 'Shows',
      'TOTALGONE':'Pessoas que decidiram não responder',
      'SELECTFPLA': 'Centros de trabalho',
      'TBARRAPROGRESO':'Progresso atual',
      'TOTALLOG':'Pessoas que ainda não concluíram a pesquisa, mas que já começaram',
      'FILTROS':{
        '1': 'Centro de Trabalho',
        '2': 'País',
        '3': 'Localização',
        '4': 'Área',
        '5': 'Grau acadêmico',
        '6': 'Departamento',
        '7': 'Nível geográfico 1',
        '8': 'Nível geográfico 2',
        '9': 'Nível geográfico 3',
        '10': 'Nível geográfico 4',
        '11': 'Nível estrutural 1',
        '12': 'Nível estrutural 2',
        '13': 'Nível estrutural 3',
        '14': 'Nível geográfico 8',
        '15': 'Nível geográfico 9',
        '16': 'Nível geográfico 10',
        '17': 'Nível hierárquico 1',
        '18': 'Nível hierárquico 2',
        '19': 'Nível hierárquico 3',
        '20': 'Nível hierárquico 4',
        '21': 'Nível hierárquico 5',
        '22': 'Nível hierárquico 6',
        '23': 'Nível hierárquico 7',
        '24': 'Nível hierárquico 8',
        '25': 'Nível hierárquico 9',
        '26': 'Nível hierárquico 10',
      }

    },
    'BTN':{
      'USERS':'Colaboradors'
    }
  }
};
